// src/data/sneacGrandFinale.js

export const eventMeta = {
  title: "SNEAC 2025–26 Grand Finale",
  fullName: "Swadhyay National Environment Awareness Competition",
  date: "Saturday, 2nd May 2026",
  venue: "Academic Heights World School, Pitampura, New Delhi",
  organizer: "Swadhyay Seva Foundation",
  heroImage: "https://res.cloudinary.com/demp2xljz/image/upload/v1779886915/R6_21845_jwexeo.jpg",
  aboutImage: "https://res.cloudinary.com/demp2xljz/image/upload/v1779886800/R6_21854_ipnsjj.jpg",
};

export const stats = [
  { value: 60, suffix: "+", label: "National Finalists", icon: "graduates" },
  { value: 18, suffix: "",  label: "States Represented", icon: "map" },
  { value: 3,  suffix: "",  label: "Quiz Rounds",         icon: "zap" },
  { value: 30, suffix: "+", label: "Audience Students",   icon: "users" },
];

export const winners = [
  {
    rank: "1st", medal: "gold",
    name: "Simratpreet Kaur", class: "Class 9",
    school: "DAV Senior Secondary Public School", city: "Badshahpur, Punjab",
    color: "from-yellow-400 to-amber-500", ring: "ring-yellow-400",
    photo: "https://res.cloudinary.com/demp2xljz/image/upload/q_auto,f_auto/v1778177092/Simratpreet_-_POONAM_SINGH_qbkxyk.jpg",
  },
  {
    rank: "2nd", medal: "silver",
    name: "Darsh Bansal", class: "Class 9",
    school: "Holy Public School", city: "Agra, Uttar Pradesh",
    color: "from-slate-400 to-slate-500", ring: "ring-slate-400",
    photo: "https://res.cloudinary.com/demp2xljz/image/upload/v1778177092/Screenshot_1_-_Holy_Public_school_oftub1.jpg",
  },
  {
    rank: "3rd", medal: "bronze",
    name: "Manvi Khatri", class: "Class 8",
    school: "Delhi Heritage School", city: "Delhi",
    color: "from-orange-400 to-amber-600", ring: "ring-orange-400",
    photo: "https://res.cloudinary.com/demp2xljz/image/upload/v1778177093/IMG_20260427_131512.jpg_-_DELHI_HERITAGE_SCHOOL_sdp2ox.jpg",
  },
];

export const chiefGuest = {
  name: "Sh. Thakur Brahmanand Singh",
  designation: "Member, Central Ground Water Board (CGWB)",
  subDesignation: "Former Member Secretary, CGWA",
  photo: "https://res.cloudinary.com/demp2xljz/image/upload/v1779801876/d9eaedcf-7f1c-4a79-95fe-c64f249bcce4.png",
};

export const distinguishedGuests = [
  {
    name: "Sh. Vinod Kumar",
    designation: "Head of Program, DD Kisan & DD Urdu, Doordarshan",
    photo: "https://res.cloudinary.com/demp2xljz/image/upload/v1778182363/vinod-kumar_fqxno1.jpg",
  },
  {
    name: "Dr. Prabir K. Naik",
    designation: "Regional Director, Central Ground Water Board, Bhujal Bhawan, Faridabad",
    photo: "https://res.cloudinary.com/demp2xljz/image/upload/v1778181489/prabir_naik_esedon.jpg",
  },
];

export const guestsOfHonour = [
  { name: "Prof. Dinabandhu Sahoo", designation: "Chairperson, RIEC, University of Delhi", photo: "https://res.cloudinary.com/demp2xljz/image/upload/v1778181489/Dinabandhu_Sahoo_rud69o.jpg" },
  { name: "Dipankar Saha",          designation: "Board-President, Water for People: India", photo: "https://res.cloudinary.com/demp2xljz/image/upload/v1778181490/Dipankar_Saha_joa6hn.jpg" },
  { name: "Surendra Sharma",        designation: "Renowned Writer, Producer & Director", photo: "https://res.cloudinary.com/demp2xljz/image/upload/v1778181489/Surendra_Sharma_mbxcb3.jpg" },
  { name: "Dr. Rakesh Singh",       designation: "Educationist & Social Activist | 30+ yrs", photo: "https://res.cloudinary.com/demp2xljz/image/upload/v1778181489/Rakesh_Singh_tz8qyj.jpg" },
  { name: "Pratibimb Sharma",       designation: "Anchor-Producer, Sansad TV", photo: "https://res.cloudinary.com/demp2xljz/image/upload/v1778181489/Pratibimb_Sharma_oedogu.jpg" },
];

export const venueDignities = [
  { name: "Ms. Rosy Ahuja",    role: "Director, Academic Heights World School" },
  { name: "Mr. Harish Nagpal", role: "Associate Director, Academic Heights World School" },
  { name: "Ms. Rachna Anand",  role: "Principal, Academic Heights World School" },
  { name: "Dr. Rekha Jha",     role: "Admission Counsellor, Academic Heights World School" },
];

export const foundationPatron = {
  name: "Dr. Madhu Ved",
  role: "Patron, Swadhyay Seva Foundation",
  designation: "Director, JPS Delhi | Dean, GILP & GICP",
  photo: "https://res.cloudinary.com/demp2xljz/image/upload/v1779877924/487d0bdc-1419-4179-a622-4627a9ccbb95.png",
};

export const schedule = [
  {
    time: "10:15 AM",
    activity:
      "Guest Arrival, Reception, Tilak Ceremony, Participant Registration & Organizational Video Presentation",
  },
  {
    time: "10:30 AM",
    activity:
      "Opening Ceremony, Welcome Address by Anchor & Introduction to SNEAC 2025–26",
  },
  {
    time: "10:45 AM",
    activity: "Traditional Diya Lighting Ceremony",
  },
  {
    time: "10:50 AM",
    activity: "Felicitation of Guests of Honour with Tulsi Pots & Mementoes",
  },
  {
    time: "11:05 AM",
    activity: "Quiz Round 1 — Batch A Finalist Verification (Online)",
  },
  {
    time: "11:15 AM",
    activity: "Quiz Round 1 — Batch A (24 Finalists)",
  },
  {
    time: "11:25 AM",
    activity: "Quiz Round 1 — Batch B Finalist Verification (Online)",
  },
  {
    time: "11:35 AM",
    activity: "Quiz Round 1 — Batch B (23 Finalists)",
  },
  {
    time: "11:50 AM",
    activity: "Result Verification & Announcement of Top 10 Qualifiers",
  },
  {
    time: "12:05 PM",
    activity: "Grand Finale Round — Top 10 Finalists",
  },
  {
    time: "12:20 PM",
    activity: "Organizational Video Presentation & Final Result Verification",
  },
  {
    time: "12:30 PM",
    activity: "Addresses by Guests of Honour & Motivational Remarks",
  },
  {
    time: "12:45 PM",
    activity: "SNEAC 2026–27 Official Launch",
  },  
  {
    time: "12:50 PM",
    activity: "Closing Remarks, Vote of Thanks & Award Ceremony",
  },
  {
    time: "01:00 PM",
    activity: "Lunch & Networking",
  },
];

export const galleryTabs = [
  {
    label: "Opening Ceremony",
    photos: [
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779801998/7f40005c-d4ae-4181-9e98-0842c9e588c5.png", caption: "Diya lighting — inauguration of the event" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779880110/R6_21942_q8bl9r.jpg", caption: "Diya lighting — guests on stage" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779880029/R6_21923_ci82wq.jpg", caption: "Tilak ceremony — welcoming Distinguished Guests" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779879729/R6_21871_bikzmf.jpg", caption: "Tilak ceremony — welcoming Guests of Honour" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779880228/R6_21962_pyem8e.jpg", caption: "Plant gifted to Distinguished Guest" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779880204/R6_21969_j4sgqd.jpg", caption: "Gifts presentation to Guests of Honour" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779880541/R6_21977_zqswwl.jpg", caption: "Memento & plant presented to Guests" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779880392/R6_21976_rwxvzd.jpg", caption: "Mementos presented to all guests" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779880493/R6_21994_zgu1ib.jpg", caption: "Mementos & gifts presented to Respected Dignitaries" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779883022/R6_21934_tqkivg.jpg", caption: "Anchor addressing the audience" },
    ],
  },
  {
    label: "Speeches & Addresses",
    photos: [
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779881116/R6_22027_zipftt.jpg", caption: "Sh. Vinod Kumar addressing students" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779881245/R6_22029_xnhuuz.jpg", caption: "Dr. Prabir K. Naik addressing the audience" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779881158/R6_22021_h5mpah.jpg", caption: "Prof. Dinabandhu Sahoo's address" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779881204/R6_22036_wyy5n0.jpg", caption: "Dipankar Saha addressing the gathering" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779881192/R6_22044_ucvflz.jpg", caption: "Pratibimb Sharma addressing the audience" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779881323/R6_22055_zxzf2x.jpg", caption: "Dr. Rakesh Singh addressing the audience" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779881138/R6_22047_fhzrtw.jpg", caption: "Surendra Sharma addressing the audience" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779881087/R6_22009_fm9gwe.jpg", caption: "Founder Manish Goel addressing the audience" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779881386/R6_22076_kd9ycu.jpg", caption: "Co-founder Rajesh Agrawal address to students" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779882184/R6_22031_zbuonq.jpg", caption: "Candid moment — guests in conversation" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779881905/R6_21894_y7lo4y.jpg", caption: "Founders with guests — candid interaction" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779882309/R6_21910_rlnyyq.jpg", caption: "Guests with the Founder" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779883131/R6_21943_dibgdz.jpg", caption: "National Anthem"},
    ],
  },
  {
    label: "Quiz Rounds",
    photos: [
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779802923/b639a25e-1439-4649-8ec7-14263f8063a3.png", caption: "Finalists joined through Zoom call" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779882836/R6_22011_ttnipa.jpg", caption: "Founder briefing audience about the competition" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779882483/R6_21933_ldhcnn.jpg", caption: "Quiz in action" },
    ],
  },
  {
    label: "Award Ceremony",
    photos: [
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779883518/R6_22081_ausne2.jpg", caption: "Winner announcement moment" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779883413/R6_22085_mpqubc.jpg", caption: "1st place — Simratpreet Kaur" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779883420/R6_22086_ejhs3z.jpg", caption: "2nd Place — Darsh Bansal" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779883416/R6_22087_uklapa.jpg", caption: "3rd Place — Manvi Khatri" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779883692/R6_22083_gslypc.jpg", caption: "Award distribution" },
    ],
  },
  {
    label: "SNEAC 2026–27 Launch",
    photos: [
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779881345/R6_22062_vhnoc6.jpg", caption: "Official launch of SNEAC 2026–27" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779884086/quiznpaint1_1_zkdktg.png", caption: "New SNEAC poster revealed on stage" },
    ],
  },
  {
    label: "Audience & Group",
    photos: [
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779884319/R6_21878_zw97c4.jpg", caption: "Student audience at the venue" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779884436/R6_21902_g09mb8.jpg", caption: "Students engaged" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779884561/R6_21921_cxcguz.jpg", caption: "Student audience wide shot" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779884579/R6_21931_cwo4v6.jpg", caption: "Whole audience wide shot" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779884958/R6_21925_ts21dj.jpg", caption: "Guests in audience" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779884789/R6_22094_vayisd.jpg", caption: "Journalist interviewing guests" },
    ],
  },
  {
    label: "Lunch",
    photos: [
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779885154/R6_22088_svkylb.jpg", caption: "Lunch spread — guests and team" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779885154/R6_22088_svkylb.jpg", caption: "Guests during lunch" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779885147/R6_22089_fyhrq4.jpg", caption: "Guests and dignitaries networking over lunch" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779885290/R6_22025_jzyv8t.jpg", caption: "Founder & Team member with guests" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779885282/R6_22090_pjesbi.jpg", caption: "Candid lunch conversation" },
      { src: "https://res.cloudinary.com/demp2xljz/image/upload/v1779885142/R6_22092_ckzdz9.jpg", caption: "Group photo at dining table" },
    ],
  },
];

export const launch2627 = {
  posterImage: "https://res.cloudinary.com/demp2xljz/image/upload/v1779884086/quiznpaint1_1_zkdktg.png",
  eventImage: "https://res.cloudinary.com/demp2xljz/image/upload/v1779881345/R6_22062_vhnoc6.jpg",
};

export const closingImage = "https://res.cloudinary.com/demp2xljz/image/upload/v1779886752/R6_22042_hwwgfk.jpg";
export const youtubeVideoId = "YOUR_YOUTUBE_VIDEO_ID";